import React, { useEffect, useRef, useState } from "react";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import "./Admin.css";
import Button from "../../components/Button/Button";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import Pagination from "../../components/Pagination/Pagination";
import {
  fetch_companies,
  fetch_individuals,
  ProposolsCount,
} from "../../services/dashboardAPI";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import Search from "../../components/SearchBar/Search";
import Table from "../../components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../components/Toast/Toast";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

let paginationPageChange = () => {};

const Admin = ({selectedTab}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { Globals ,languages, setLanguages } = useLanguage();
  const { toastValue, activeTabData } = location.state || '';
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState(activeTabData|| OldGlobals.ADMIN.COMPANIES);
  const [companyIndividualData, setCompanyIndividualData] = useState(null);
  const [companyIndividualDataStatus, setCompanyIndividualDataStatus] = useState(null);
  const [totalCount, setTotalCount] = useState();
  const [proposalCount, setProposalCount] = useState([]);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [dataSorting, setDatasorting] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [toast, setToast] = useState({open:false, status:'', title:""});

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      DATE: {
        selected: [],
        selectedMonthYear: [],
        selectedText: [],
        isDatePicker: true,
        isloading: false,
      },
    },
  });

  const dropdownRefs = useRef({});
  const prevSelectedState = useRef({});

  const isInitialRenderPage = useRef(true);
  const isInitialRenderSort = useRef(true);
  const isInitialRenderDropdown = useRef(true);
  const isInitialRenderSearch = useRef(true);
   const isInitialRenderLanguages = useRef(true);

  const handleRowClick = (item) => {
    setSelectedItem(item);
  };

  const getUserRecords = (userRecord) => {
    const producerID=userRecord?.producerId || userRecord?.producerI || '0c60d644-066c-4d6a-ace4-1943c44c2d99'
    CryptoUtils.saveToLocalStorage('pKey', producerID);
    const navigationUrl = activeTab === OldGlobals.ADMIN.COMPANIES ? 'SYS_ADMIN_COMP_APPROVE_REJECT' : 'SYS_ADMIN_PRODUCER_APPROVE_REJECT'
    navigate(Globals.NAVPATH[navigationUrl],{state:{activeHeader:selectedTab}});
  }

  //first time Fetching data
  useEffect(() => {
    fetchPorposolsCount("All", "All");
  }, []);

  //Tab Change useEffect
  useEffect(() => {
    handleClearAll();
    setCompanyIndividualDataStatus(null);
    setCompanyIndividualData(null);
    setTotalCount(null);
    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown.selected.length >= 0
    );

    if (hasSelectedOptions) {
      const data = {
        registrationDate:
          dropdownState.dropdowns.DATE.selected.length > 0
            ? dropdownState.dropdowns.DATE.selected
            : "string",
        search: searchQuery ? searchQuery : "",
        filter: dataSorting,
      };
      paginationPageChange(1);
      fetchCompaniesIndividuals(data, 1, activeTab);
    }
  }, [activeTab]);

  //DropdownState useEffect
  useEffect(() => {
    if (isInitialRenderDropdown.current) {
      isInitialRenderDropdown.current = false;
      return; // Skip on first render
    }

    let hasChanges = false;
    const hasSelectedOptions = Object.values(dropdownState?.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown?.selected.length >= 0
    );
    const hasselectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown.selected.length > 0
    );

    if (hasselectedOptions) {
      setEnableClearAll(true);
    } else {
      setEnableClearAll(false);
    }

    Object.keys(dropdownState.dropdowns).forEach((key) => {
      const currentSelected = dropdownState.dropdowns[key]?.selected;
      const prevSelected = prevSelectedState.current[key]?.selected;

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasChanges = true;
        if (hasSelectedOptions) {
          const data = {
            registrationDate:
              dropdownState.dropdowns.DATE.selected.length > 0
                ? dropdownState.dropdowns.DATE.selected
                : "string",
            search: searchQuery ? searchQuery : "",
            filter: dataSorting,
          };
          paginationPageChange(1);
          fetchCompaniesIndividuals(data, 1, activeTab);
        }
      }
    });

    if (hasChanges) {
      prevSelectedState.current = { ...dropdownState.dropdowns }; // Update the reference with new selected values
    }
  }, [dropdownState]);

  //CurrentPage useEffect
  useEffect(() => {
    if (isInitialRenderPage.current) {
      isInitialRenderPage.current = false;
      return; // Skip on first render
    }

    const data = {
      registrationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchCompaniesIndividuals(data, currentPage, activeTab);
  }, [currentPage]);

  //Search useEffect
  useEffect(() => {
    if (isInitialRenderSearch.current) {
      isInitialRenderSearch.current = false;
      return; // Skip on first render
    }
    const data = {
      registrationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchCompaniesIndividuals(data, 1, activeTab);
  }, [searchQuery]);

  //Sorting useEffect
  useEffect(() => {
    if (isInitialRenderSort.current) {
      isInitialRenderSort.current = false;
      return; // Skip on first render
    }

    const data = {
      registrationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchCompaniesIndividuals(data, currentPage, activeTab);
  }, [dataSorting]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all dropdowns
      const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
        ref?.contains(event.target)
      );
      if (!isClickInsideDropdown) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (toastValue) {
      setToast(toastValue);
      setTimeout(() => {
        setToast({open:false, status:'',title:''});
      }, 4000);
    }
  }, [toastValue]);

  const onPageChange = (pageNumber, setPage = () => {}) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  async function fetchCompaniesIndividuals(filters, pagenumber, activetab) {
    try {
      let responseData;
      if (activetab === OldGlobals.ADMIN.COMPANIES) {
        responseData = await fetch_companies(filters, pagenumber);
        setCompanyIndividualData(responseData?.data?.content?.companyDetails);
        setCompanyIndividualDataStatus(responseData?.status);
        setTotalCount(responseData?.data?.content?.pageCount);
      } else if (activetab === OldGlobals.ADMIN.INDIVIDUALS) {
        responseData = await fetch_individuals(filters, pagenumber);
        setCompanyIndividualData(responseData?.data?.content?.individualDetails);
        setCompanyIndividualDataStatus(responseData?.status);
        setTotalCount(responseData?.data?.content?.pageCount);
      }
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  }

  const fetchPorposolsCount = async (type, date) => {
    try {
      const response = await ProposolsCount(type, date);
      setProposalCount(response.data.content);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  //Initial useEffect
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  //handle Toogle
  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  //handleClearAll dropdowns
  const handleClearAll = () => {
    if (enableClearAll) {
      setCompanyIndividualDataStatus(null);
      setCurrentPage(1);
      setDatasorting(1);
      setEnableClearAll(false);
      setSearchQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }
  };

  //handleDateChange dropdowns
  const handleDateChange = (dropdownName, date) => {
    setCompanyIndividualDataStatus(null);
    if (date instanceof Date && !isNaN(date)) {
      const month = date.getMonth() + 1; // Months are 0-based
      const year = date.getFullYear();

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const MonthName = monthNames[month - 1];

      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            selected: month + "-" + year,
            selectedMonthYear: month + "," + year,
            selectedText: MonthName + "-" + year,
          },
        },
      }));
    }
  };

  //handleSorting
  const handleSorting = (sorting) => {
    setDatasorting(sorting);
  };

  //handleSearch
  const handleSearch = (term) => {
    setSearchQuery(term);
    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setCompanyIndividualDataStatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  //language change logic
    useEffect(() => {
      if (isInitialRenderLanguages.current) {
        isInitialRenderLanguages.current = false;
        return; // Skip on first render
      }
      setDatasorting(1);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });

      const data = {
      registrationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchCompaniesIndividuals(data, 1, activeTab);

    }, [languages]);

  return (
    <div className="admin">
      <div className="admin-top">
        <div className="admin-heading">{Globals.PRODUCER.DASHBOARD}</div>
        <Button
          optionalTitle={"+"}
          title={Globals.INTERNAL.NEWCLUSTER}
          additionalStyle={"new-cluster-dashboard"}
          id={"Create_New_Cluster"}
          action ={()=>{
            navigate(Globals.NAVPATH.ADD_CLUSTER, {state: { activeHeader: selectedTab}})
          }}
        />
      </div>

      <div className="admin-overview">
        <div className="users-overview">
          <div className="proposals-heading">
            <div>{Globals.ADMIN.USERS}</div>
          </div>

          <div className="summary-cards">
            {proposalCount && proposalCount.length > 0
              ? proposalCount?.map((item) => (
                  <>
                    {Object.keys(item)
                      .slice(0)
                      .map((key) => (
                        <SummaryCard
                          key={`${item.id}-${key}`}
                          title={key}
                          count={item[key]}
                          submissionType
                        />
                      ))}
                  </>
                ))
              : companyIndividualDataStatus &&
                companyIndividualDataStatus.length > 0 && (
                  <div className="no-data">
                    {/* <NoResultsComponent
                      data={{
                        message: Globals.NO_RESULTS_MESSAGE,
                        img: Globals.NO_RESULTS_IMG,
                        submessage: Globals.NO_RESULTS_DASHBOARD_MESSAGE,
                      }}
                    /> */}
                  </div>
                )}
          </div>
        </div>
      </div>

      <div className="dashboard-brief">
        <div className="dashboard-breif_heading">{Globals.ADMIN.APPROVALS}</div>
        <div className="dashboard-brief-tabs">
          <div
            className={`dashboard-brief-tab ${
              activeTab === OldGlobals.ADMIN.COMPANIES ? "active" : ""
            }`}
            onClick={() => handleTabClick(OldGlobals.ADMIN.COMPANIES)}
          >
            {Globals.ADMIN.COMPANIES}
          </div>
          <div
            className={`dashboard-brief-tab ${
              activeTab === OldGlobals.ADMIN.INDIVIDUALS ? "active" : ""
            }`}
            onClick={() => handleTabClick(OldGlobals.ADMIN.INDIVIDUALS)}
          >
            {Globals.ADMIN.INDIVIDUALS}
          </div>
        </div>

        <div className="filters">
          <div className="results">
            {totalCount}{" "}
            {activeTab === OldGlobals.ADMIN.COMPANIES ? Globals.ADMIN.PRODUCERS : Globals.ADMIN.USERS}
          </div>
          <div className="row_spearator"></div>
          <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

          <CheckboxDropDown
            isOpen={activeDropdown === "DATE"}
            options={dropdownState.dropdowns.DATE.options}
            onToggle={() => handletog("DATE")}
            title={Globals.FILTER.REGDATE}
            isDatePicker={true}
            selectedValues={dropdownState.dropdowns.DATE.selected}
            selectedMonthYear={dropdownState.dropdowns.DATE.selectedMonthYear}
            selectedMonthYearText={dropdownState.dropdowns.DATE.selectedText}
            dropdownRef={(el) => (dropdownRefs.current["Date"] = el)}
            onDateChange={(date) => handleDateChange("DATE", date)}
          />

          <div
            className={enableClearAll ? "clear clearAllEnable" : "clear"}
            onClick={() => handleClearAll()}
          >
            {Globals.PRODUCER.CLEARALL}
          </div>

          <div className="search">
            <Search
              onSearch={handleSearch}
              searchedFor={searchQuery}
              placeholder={
                activeTab === OldGlobals.ADMIN.COMPANIES
                  ? Globals.ADMIN.SEARCHCOMPANY
                  : Globals.ADMIN.SEARCHINDIVIDUAL
              }
            />
          </div>
        </div>

        <div className="Table_Data">
          {companyIndividualData && companyIndividualData.length > 0 ? (
            <Table data={companyIndividualData} onSort={handleSorting} onRowClick={()=>handleRowClick('')} userRecord={(userRecord)=>getUserRecords(userRecord)} sortKey ={dataSorting}/>
          ) : companyIndividualDataStatus ? (
            <div className="no-data">
              <NoResultsComponent
                data={{
                  message:
                    dropdownselected || (searchQuery && searchQuery.length > 0)
                      ? Globals.NO_RESULTS_MESSAGE
                      : Globals.NO_DATA_WITHOUTFILTER,
                  img:
                    dropdownselected || (searchQuery && searchQuery.length > 0)
                      ? OldGlobals.NO_RESULTS_IMG
                      : OldGlobals.NO_DATA_FOUND_IMG,
                  submessage:
                    dropdownselected || (searchQuery && searchQuery.length > 0)
                      ? Globals.NO_RESULTS_SUBMESSAGE
                      : "",
                }}
              />
            </div>
          ) : (
            <div>
              <Loader height={80} width={80} component={"Dashboard"} />
            </div>
          )}
        </div>

        <div className="pagination-container">
          {companyIndividualData && companyIndividualData?.length > 0 && (
            <Pagination
              totalPages={Math.ceil(totalCount / Globals.MAX_COUNT.TABLE_DATA_COUNT)}
              currentPage={currentPage}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>
      {toast.open && <Toast status={toast.status} onClose={()=>{setToast({open:false, status:'', title:''});}} title={toast.title} />}
    </div>
  );
};

export default Admin;
